import { useMutation } from "react-query";
import { EditarTenantTipoConsumoForm } from "../typings/index";
import http from "infra/http";

function useSaveTenantTipoConsumo() {
  return useMutation(
    (data: EditarTenantTipoConsumoForm) => {
      return http.put(`/v1/consumo/tenant-tipo-consumo`, data);
    },
    { retry: false }
  );
}

export default useSaveTenantTipoConsumo;
